export interface FetchApplicableAddonsResponse {
  success: boolean;
  data: Array<{
    id: string;
    name: string;
    items: Array<{
      id: string;
      title: string;
      handle: string;
      description: string;
      images: Array<{
        id: string;
        src: string;
        alt: string;
      }>;
      variants: Array<{
        id: string;
        title: string;
        price: string;
        compare_at_price?: string;
        sku: string;
        available: boolean;
        selectedOptions: Array<{
          name: string;
          value: string;
        }>;
      }>;
    }>;
    metadata_fields: Array<{
      id: string;
      field_name: string;
      field_type: 'textfield' | 'option';
      field_options: string[];
      required: boolean;
      display_order: number;
      max_length?: number | null;
      remove_special_chars?: boolean;
      remove_numbers?: boolean;
    }>;
  }>;
}

export async function fetchApplicableAddons(
  apiUrl: string,
  productId: string,
  variantId: string
): Promise<FetchApplicableAddonsResponse> {
  const url = `${apiUrl}/product-addons/product/${productId}/variant/${variantId}`;
  
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch applicable addons: ${response.statusText}`);
  }

  return response.json();
}

